
export default class AiChatMessage_TokenUsage {

    public totalTokens  : number
    public inputTokens  : number
    public outputTokens : number
    public cachedTokens : number
    public cost : number

    public raw?         : DictionaryStringAny

    constructor(data: any) {
        this.totalTokens    = _.get(data, 'totalTokens', 0)
        this.inputTokens    = _.get(data,'inputTokens', 0)
        this.cachedTokens   = _.get(data,'cachedTokens', 0)
        this.outputTokens   = _.get(data,'outputTokens', 0)
        this.cost   = _.get(data,'cost', 0) // counted in collection

        this.raw            = _.get(data, 'raw', {})
    }



}
